var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 26.7112C18.8286 26.7112 21.5418 25.5874 23.5421 23.587C25.5425 21.5866 26.6663 18.8735 26.6663 16.0446C26.6663 13.2156 25.5425 10.5025 23.5421 8.50209C21.5418 6.50171 18.8286 5.3779 15.9997 5.3779C13.1707 5.3779 10.4576 6.50171 8.4572 8.50209C6.45681 10.5025 5.33301 13.2156 5.33301 16.0446C5.33301 18.8735 6.45681 21.5866 8.4572 23.587C10.4576 25.5874 13.1707 26.7112 15.9997 26.7112ZM17.333 12.0446C17.333 11.6909 17.1925 11.3518 16.9425 11.1018C16.6924 10.8517 16.3533 10.7112 15.9997 10.7112C15.6461 10.7112 15.3069 10.8517 15.0569 11.1018C14.8068 11.3518 14.6663 11.6909 14.6663 12.0446V14.7112H11.9997C11.6461 14.7112 11.3069 14.8517 11.0569 15.1018C10.8068 15.3518 10.6663 15.6909 10.6663 16.0446C10.6663 16.3982 10.8068 16.7373 11.0569 16.9874C11.3069 17.2374 11.6461 17.3779 11.9997 17.3779H14.6663V20.0446C14.6663 20.3982 14.8068 20.7373 15.0569 20.9874C15.3069 21.2374 15.6461 21.3779 15.9997 21.3779C16.3533 21.3779 16.6924 21.2374 16.9425 20.9874C17.1925 20.7373 17.333 20.3982 17.333 20.0446V17.3779H19.9997C20.3533 17.3779 20.6924 17.2374 20.9425 16.9874C21.1925 16.7373 21.333 16.3982 21.333 16.0446C21.333 15.6909 21.1925 15.3518 20.9425 15.1018C20.6924 14.8517 20.3533 14.7112 19.9997 14.7112H17.333V12.0446Z",
    fill: "#18173C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircle);
export default __webpack_public_path__ + "static/media/pluscircle.f0750f84e01d7b4d2c88aea0854e6ea4.svg";
export { ForwardRef as ReactComponent };